


























































































































import { Component, Vue } from "vue-property-decorator";
import AdsModal from "./modals/addAds.vue";
import EditModal from "./modals/editAds.vue";
import Ajax from '../..//lib/ajax';
import Advert from "@/store/entities/advert";
@Component({
  components: { AdsModal,EditModal },
})

export default class Ads extends Vue {
  search: string = "";
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  isOpenAdsModal: boolean = false;
  adverts: Advert[] = [];
  isUpdateModal:boolean=false;
  selectedItem:Advert=new Advert();

  closeUpdateModal() {
    this.isUpdateModal = false;
    this.getAds();
  }

  confirmDelete(item) {
    this.$swal({
      title: "Kayıt Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then(async (result) => {
      if (result.isConfirmed) {
        
       await  Ajax.delete(
        '/api/services/app/Admin/DeleteAdvert?input=' + item.id
      );

        Vue.$toast.success("Silme Başarılı");

        this.getAds();
      }
    
    });
  }
  updateAds(item) {
    this.selectedItem=item;
    this.isUpdateModal = true;
  }
  
  async created() {
    (this.headers = [
   
      { text: "Görsel", value: "img" },
      { text: "İlan Tarihi", value: "adDate" },
      { text: "İlan Veren", value: "advertiser" },
      { text: "Meslek", value: "occupation" },
      { text: "E-Posta", value: "email" },
      { text: "Telefon", value: "mobile" },
      { text: "Şehir", value: "city" },
      { text: "Kategori", value: "category" },
      { text: "Ödeme", value: "payment" },
      { text: "Onayla", value: "payment" },
      { text: "İşlemler", value: "transactions" },

    ]),

      

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "İlanlar", disabled: true },
    ];

    await this.getAds();
  }

  async getAds(){
    var response = await Ajax.get(
        '/api/services/app/Admin/GetAdverts'
      );
      var data = response.data.result.items;
      this.adverts=data;
  }
  confirmAdvert(item) {
    this.$swal({
      title: "İlan Onaylanacaktır emin misiniz ?",      
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText:"İptal",
      confirmButtonText: "Onayla",
    }).then((result) => {
      if (result.isConfirmed) {
       this.confirmAdvertService(item);
      }
    });
  }

  async confirmAdvertService(item){
    await Ajax.post(
        '/api/services/app/Admin/ConfirmAdvert?input='+item.id
      );
      this.getAds();
      Vue.$toast.success("İlan Onaylandı");
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    
    };
  }
  

  cancelModal() {
    this.isOpenAdsModal = false;
    this.isUpdateModal = false;
  }


  openAdsModal() {
    this.isOpenAdsModal = true;
  }
  closeAdsModal() {
    this.isOpenAdsModal = false;
     this.getAds();
  }



}
